import { Component, h, Prop } from '@stencil/core';

/**
 * Icon Component
 */
@Component({
  tag: 'ad-icon',
  styleUrl: 'ad-icon.css',
  assetsDirs: ['assets'],
  shadow: false,
})

export class AdessoIcon {
    /** Icon name - for example: chevron-down */
    @Prop({reflect: true, mutable: true }) icon: string;

    render() {
        return <i class={`fa-thin fa-${this.icon}`}></i>; 
    }
}